module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"container\"> <div class=\"form-container\"> <% if(headline1){ %><h1><%= headline1 %></h1><% } %> <form class=\"user-form form\"> <% _.each(fields, function (field, index) { %> <% if(columns===0 || columns >= 12 || field.type === \"select_dob\") {\n\t\t\t\t\tcolumns = 0;\n\t\t\t\t%> <div class=\"row\"> <% } %> <%\tif(field.column.indexOf('eleven') > -1)\n\t\t\t\t\t\tcolumns += 11;\n\t\t\t\t\telse if(field.column.indexOf('ten') > -1)\n\t\t\t\t\t\tcolumns += 10;\n\t\t\t\t\telse if(field.column.indexOf('nine') > -1)\n\t\t\t\t\t\tcolumns += 9;\n\t\t\t\t\telse if(field.column.indexOf('eight') > -1)\n\t\t\t\t\t\tcolumns += 8;\n\t\t\t\t\telse if(field.column.indexOf('seven') > -1)\n\t\t\t\t\t\tcolumns += 7;\n\t\t\t\t\telse if(field.column.indexOf('six') > -1)\n\t\t\t\t\t\tcolumns += 6;\n\t\t\t\t\telse if(field.column.indexOf('five') > -1)\n\t\t\t\t\t\tcolumns += 5;\n\t\t\t\t\telse if(field.column.indexOf('four') > -1)\n\t\t\t\t\t\tcolumns += 4;\n\t\t\t\t\telse if(field.column.indexOf('three') > -1)\n\t\t\t\t\t\tcolumns += 3;\n\t\t\t\t\telse if(field.column.indexOf('two') > -1)\n\t\t\t\t\t\tcolumns += 2;\n\t\t\t\t\telse if(field.column.indexOf('one') > -1)\n\t\t\t\t\t\tcolumns += 1;\n\t\t\t\t\telse\n\t\t\t\t\t\tcolumns = 0;\n\n                %> <% if (field.type !== 'select_dob') { %> <div class=\"<%= field.column %>\"> <% } %> <% if(field.type === \"input\") { %> <% if(field.label.length > 0) { %> <label for=\"<%= field.id + styleID %>\"><%- field.label %></label> <% } %> <input id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" class=\"u-full-width\" type=\"text\" placeholder=\"<%= field.placeholder %>\" maxlength=\"<%= field.max_length%>\"> <% } else if(field.type === \"checkbox\") { %> <div class=\"checkbox\"> <input id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" type=\"checkbox\"> <label for=\"<%= field.id + styleID %>\"><%- field.label %></label> </div> <% } else if (field.type === 'select_dob') { %> <div class=\"dob-container twelve columns\"> <label for=\"<%= field.id %>\"><%- field.label %></label> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" class=\"u-full-width\" data-type=\"month\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Month</option> <% _.each(months, function (option, index) { %> <option value=\"<%= option %>\"><%= option %></option> <% }); %> </select> </div> </div> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" class=\"u-full-width\" data-type=\"day\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Day</option> <% _.each(days, function (option, index) { %> <option value=\"<%= option %>\"><%= option %></option> <% }); %> </select> </div> </div> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" class=\"u-full-width\" data-type=\"year\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Year</option> <% _.each(years, function (option, index) { %> <option value=\"<%= option %>\"><%= option %></option> <% }); %> </select> </div> </div> <% if( [\"true\",\"1\"].indexOf(field.required) >= 0 ){ %> <div id=\"invalid-dob\" style=\"display: none;\" class=\"error-message\"> <%= field.error_message %> </div> <% } %> </div> <% } else if(field.type === \"select\") { %> <% if(field.label.length > 0) { %> <label for=\"<%= field.id + styleID %>\"><%- field.label %></label> <% } %> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"<%= field.id + styleID %>\" name=\"<%= field.id %>\" class=\"u-full-width\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\"><%= field.placeholder %></option> <% _.each(field.options_list, function (option, index) { %> <option value=\"<%= option %>\"><%= option %></option> <% }); %> </select></div> <% } %> <div class=\"error-message <%=field.type%>\"><%= field.error_message %></div> <% if (field.type !== 'select_dob') { %> </div> <% } %> <% if(columns===0 || columns >= 12 || field.type === \"select_dob\") {\n\t\t\t\t\tcolumns = 0;\n\t\t\t\t%> </div> <% } %> <% }) %> <br> <%\n          var displayIcon = ( customizations.buttons && [ \"false\", \"0\" ].indexOf( customizations.buttons.display_icon ) === -1 );\n          displayIcon = false;\n        %> <div class=\"option-links\"> <button type=\"submit\" class=\"active\" <%= displayIcon ? '' : 'style=\"padding-left:0;\"' %>> <div class=\"normal\"><%= submit_button %> <% if( displayIcon ){ %> <img class=\"svg\" src=\"images/playbutton.svg\"> <% } %> </div> <div class=\"loading-text\"><%= loading_text %> <img src=\"https://ts-cms-dev.s3-us-west-1.amazonaws.com/campaign/10/00/1000540/14497740095669cbb908de99.85843824.gif\" class=\"upload-img loading-img\"></div> </button> <a href=\"#\" class=\"cancel\"><%= cancel_text %></a> </div> </form> </div> </div>"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"container\"> <div class=\"form-container\"> ")
    ;  if(headline1){ 
    ; __append("<h1>")
    ; __append(escapeFn( headline1 ))
    ; __append("</h1>")
    ;  } 
    ; __append(" <form class=\"user-form form\"> ")
    ;  _.each(fields, function (field, index) { 
    ; __append(" ")
    ;  if(columns===0 || columns >= 12 || field.type === "select_dob") {
					columns = 0;
				
    ; __line = 3
    ; __append(" <div class=\"row\"> ")
    ;  } 
    ; __append(" ")
    ; 	if(field.column.indexOf('eleven') > -1)
						columns += 11;
					else if(field.column.indexOf('ten') > -1)
						columns += 10;
					else if(field.column.indexOf('nine') > -1)
						columns += 9;
					else if(field.column.indexOf('eight') > -1)
						columns += 8;
					else if(field.column.indexOf('seven') > -1)
						columns += 7;
					else if(field.column.indexOf('six') > -1)
						columns += 6;
					else if(field.column.indexOf('five') > -1)
						columns += 5;
					else if(field.column.indexOf('four') > -1)
						columns += 4;
					else if(field.column.indexOf('three') > -1)
						columns += 3;
					else if(field.column.indexOf('two') > -1)
						columns += 2;
					else if(field.column.indexOf('one') > -1)
						columns += 1;
					else
						columns = 0;

                
    ; __line = 28
    ; __append(" ")
    ;  if (field.type !== 'select_dob') { 
    ; __append(" <div class=\"")
    ; __append(escapeFn( field.column ))
    ; __append("\"> ")
    ;  } 
    ; __append(" ")
    ;  if(field.type === "input") { 
    ; __append(" ")
    ;  if(field.label.length > 0) { 
    ; __append(" <label for=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> ")
    ;  } 
    ; __append(" <input id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" class=\"u-full-width\" type=\"text\" placeholder=\"")
    ; __append(escapeFn( field.placeholder ))
    ; __append("\" maxlength=\"")
    ; __append(escapeFn( field.max_length))
    ; __append("\"> ")
    ;  } else if(field.type === "checkbox") { 
    ; __append(" <div class=\"checkbox\"> <input id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" type=\"checkbox\"> <label for=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> </div> ")
    ;  } else if (field.type === 'select_dob') { 
    ; __append(" <div class=\"dob-container twelve columns\"> <label for=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" class=\"u-full-width\" data-type=\"month\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Month</option> ")
    ;  _.each(months, function (option, index) { 
    ; __append(" <option value=\"")
    ; __append(escapeFn( option ))
    ; __append("\">")
    ; __append(escapeFn( option ))
    ; __append("</option> ")
    ;  }); 
    ; __append(" </select> </div> </div> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" class=\"u-full-width\" data-type=\"day\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Day</option> ")
    ;  _.each(days, function (option, index) { 
    ; __append(" <option value=\"")
    ; __append(escapeFn( option ))
    ; __append("\">")
    ; __append(escapeFn( option ))
    ; __append("</option> ")
    ;  }); 
    ; __append(" </select> </div> </div> <div class=\"four columns small\"> <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" class=\"u-full-width\" data-type=\"year\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">Year</option> ")
    ;  _.each(years, function (option, index) { 
    ; __append(" <option value=\"")
    ; __append(escapeFn( option ))
    ; __append("\">")
    ; __append(escapeFn( option ))
    ; __append("</option> ")
    ;  }); 
    ; __append(" </select> </div> </div> ")
    ;  if( ["true","1"].indexOf(field.required) >= 0 ){ 
    ; __append(" <div id=\"invalid-dob\" style=\"display: none;\" class=\"error-message\"> ")
    ; __append(escapeFn( field.error_message ))
    ; __append(" </div> ")
    ;  } 
    ; __append(" </div> ")
    ;  } else if(field.type === "select") { 
    ; __append(" ")
    ;  if(field.label.length > 0) { 
    ; __append(" <label for=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\">")
    ; __append( field.label )
    ; __append("</label> ")
    ;  } 
    ; __append(" <div class=\"styled-select\"> <img src=\"../images/selectarrow.svg\" class=\"svg\"> <select id=\"")
    ; __append(escapeFn( field.id + styleID ))
    ; __append("\" name=\"")
    ; __append(escapeFn( field.id ))
    ; __append("\" class=\"u-full-width\"> <option value=\"\" disabled=\"disabled\" selected=\"selected\">")
    ; __append(escapeFn( field.placeholder ))
    ; __append("</option> ")
    ;  _.each(field.options_list, function (option, index) { 
    ; __append(" <option value=\"")
    ; __append(escapeFn( option ))
    ; __append("\">")
    ; __append(escapeFn( option ))
    ; __append("</option> ")
    ;  }); 
    ; __append(" </select></div> ")
    ;  } 
    ; __append(" <div class=\"error-message ")
    ; __append(escapeFn(field.type))
    ; __append("\">")
    ; __append(escapeFn( field.error_message ))
    ; __append("</div> ")
    ;  if (field.type !== 'select_dob') { 
    ; __append(" </div> ")
    ;  } 
    ; __append(" ")
    ;  if(columns===0 || columns >= 12 || field.type === "select_dob") {
					columns = 0;
				
    ; __line = 30
    ; __append(" </div> ")
    ;  } 
    ; __append(" ")
    ;  }) 
    ; __append(" <br> ")
    ; 
          var displayIcon = ( customizations.buttons && [ "false", "0" ].indexOf( customizations.buttons.display_icon ) === -1 );
          displayIcon = false;
        
    ; __line = 33
    ; __append(" <div class=\"option-links\"> <button type=\"submit\" class=\"active\" ")
    ; __append(escapeFn( displayIcon ? '' : 'style="padding-left:0;"' ))
    ; __append("> <div class=\"normal\">")
    ; __append(escapeFn( submit_button ))
    ; __append(" ")
    ;  if( displayIcon ){ 
    ; __append(" <img class=\"svg\" src=\"images/playbutton.svg\"> ")
    ;  } 
    ; __append(" </div> <div class=\"loading-text\">")
    ; __append(escapeFn( loading_text ))
    ; __append(" <img src=\"https://ts-cms-dev.s3-us-west-1.amazonaws.com/campaign/10/00/1000540/14497740095669cbb908de99.85843824.gif\" class=\"upload-img loading-img\"></div> </button> <a href=\"#\" class=\"cancel\">")
    ; __append(escapeFn( cancel_text ))
    ; __append("</a> </div> </form> </div> </div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}